<div class="checkout-prioritization-container">
  <form [formGroup]="formGroup">
    <div class="header">
      <div class="header-title">
        <pdq-heading element="h5">Checkout Prioritization</pdq-heading>
      </div>
    </div>

    <div>
      <div class="content">
        Decide how customers are assigned when they match more than one checkout group
        <pdq-radio-group [formControl]="formGroup.controls['enableCheckoutPrioritization']">
          <pdq-radio-button
            [value]="false"
            [checked]="formGroup.value['enableCheckoutPrioritization'] == false"
            text="Automatic prioritization"
            subText="We’ll assign customers to the checkout group that fits them best, the one that matches the most rules. It’s the smartest way to ensure every shopper gets the most relevant checkout experience."></pdq-radio-button>
          <pdq-radio-button
            [value]="true"
            [checked]="formGroup.value['enableCheckoutPrioritization'] == true"
            text="Custom prioritization"
            subText="Set your own order of checkout groups. Drag and drop to choose which groups take priority when a customer qualifies for more than one."></pdq-radio-button>
        </pdq-radio-group>
        <div class="info-box">
          <div class="info-text">
            <pdq-icon size="x-large" icon="more_information" color="var(--on-surface-light)"></pdq-icon>
            You can reorder checkout groups in the Checkout Groups section after saving
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
